var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlog = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.278 14.633a.819.819 0 0 0 .606-.25l9.501-9.468h.001a.835.835 0 0 0 0-1.182v-.001l-2.084-2.084H12.3a.833.833 0 0 0-1.182 0l-9.45 9.45a.819.819 0 0 0-.301.583l-.002.02.04 2.892 2.872.04Zm9.285-10.31L11.71 2.47l-1.533 1.533 1.85 1.85 1.536-1.53ZM11.319 6.56 9.47 4.71l-7.102 7.102.025 1.795 1.828.025 7.098-7.073Zm-7.025 7.074h.004l-.011.5.007-.5Z",
    fill: "#9999AC"
  })));
};
export default SvgBlog;